import type { src_issueViewLayoutTemplatesLayoutItem_LayoutItemInternal$data as LayoutItemInternalData } from '@atlassian/jira-relay/src/__generated__/src_issueViewLayoutTemplatesLayoutItem_LayoutItemInternal.graphql';

export const isRelayDataReady = (
	relayData: LayoutItemInternalData | null,
): relayData is LayoutItemInternalData => relayData !== null;
